import { render, staticRenderFns } from "./SettingRole.vue?vue&type=template&id=788e6f8e&scoped=true&"
import script from "./SettingRole.vue?vue&type=script&lang=js&"
export * from "./SettingRole.vue?vue&type=script&lang=js&"
import style0 from "./SettingRole.vue?vue&type=style&index=0&id=788e6f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e6f8e",
  null
  
)

export default component.exports